import { apiClient } from '../../../api/client'
import { downloadXlsx } from '../../../lib/download'
import type { Grant, GrantStatus, GrantUpsert, PagedResponse } from '../types'

const BASE = '/management/grants'

/** Silinmemiş yetkiler (yönetim ölçeği küçük → tek sayfada size=200). */
export async function getGrants(): Promise<PagedResponse<Grant>> {
  const { data } = await apiClient.get<PagedResponse<Grant>>(BASE, { params: { page: 0, size: 200 } })
  return data
}

export async function createGrant(body: GrantUpsert): Promise<Grant> {
  const { data } = await apiClient.post<Grant>(BASE, body)
  return data
}

export async function updateGrant(id: number, body: GrantUpsert): Promise<Grant> {
  const { data } = await apiClient.put<Grant>(`${BASE}/${id}`, body)
  return data
}

export async function changeGrantStatus(id: number, body: GrantStatus): Promise<Grant> {
  const { data } = await apiClient.put<Grant>(`${BASE}/${id}/status`, body)
  return data
}

export async function deleteGrant(id: number): Promise<void> {
  await apiClient.delete(`${BASE}/${id}`)
}

/**
 * Yetki listesini Excel (.xlsx) olarak indirir.
 *
 * Liste ucuyla aynı filtreler; sunucu **tüm** filtreli kayıtları döndürür (sayfalama yok). İndirme
 * mekaniği ve dosya adı ortak {@link downloadXlsx} yardımcısındadır (boş filtreler gönderilmez; ad
 * sunucunun Content-Disposition'ından okunur).
 */
export async function exportGrants(q?: string): Promise<void> {
  await downloadXlsx(`${BASE}/export`, { q }, 'yetkiler.xlsx')
}
